import { useQuery } from "@tanstack/react-query";
import axiosInstance from "../utils/axios";

// The header settings payload has no shortName, so the Community record is the
// only real source for the community short name (e.g. "TOSCANA").
export const useCommunityShortName = () => {
  const { data: community } = useQuery({
    queryKey: ["community"],
    queryFn: async () => {
      const response = await axiosInstance.get("/api/community");
      return response.data;
    },
    // The community record barely changes; this hook mounts on every page that
    // shows the sidebar form, so don't refetch it on each mount/window focus.
    staleTime: 5 * 60 * 1000,
  });

  // Empty while loading or on error, so callers keep their own fallback chain.
  return community?.shortName || "";
};
